module.exports = __webpack_public_path__ + "img/美妆-11.4788c52c.png";